module.exports = __webpack_public_path__ + "img/close-white.c558ec23.svg";